import React from "react";
import parse from "html-react-parser";
import { SettingsCodeEnum } from "./SettingsCodeEnum";

export function getValueAsString(graphData, codeName: SettingsCodeEnum) {
    try {
        return graphData.nodes.filter(nav => nav.CodeName == codeName)[0].Properties.value;
    } catch(error) {
        console.error(`Failed to get GraphQL value for ${codeName} from settings table`, error);
        throw error;
    }
}

export function getValueAsJSON(graphData, codeName: SettingsCodeEnum) {
    try {
        return JSON.parse(getValueAsString(graphData, codeName));
    } catch (error) {
        console.error(`Error parsing ${codeName} from settings table`, error);
        throw error;
    }
}

export function getValueAsDelimitedList(graphData, codeName: SettingsCodeEnum) {
    try {
        return getValueAsString(graphData, codeName)
            .toLowerCase()
            .split(/[\n,]/)
            .map(path => path.replace(/\r/, "").trim())
            .filter(path => Boolean(path));
    } catch (error) {
        console.error(`customData: error parsing ${codeName} in getValueAsDelimitedList`, error);
        return [];
    }
}

export function getValueAsHtml(graphData, codeName: SettingsCodeEnum) {
    try {
        const value = getValueAsString(graphData, codeName);
        return parse(value);
    } catch (error) {
        console.error(`customData: error parsing ${codeName} in getValueAsHtml`, error);
        return <div style={{display: "none"}}>getValueAsHtml failed: could not parse {codeName} html</div>;
    }
}

export function getAllValues(graphData) {
    try {
        return graphData.nodes.reduce((acc, node) => {
            const { CodeName, Properties } = node;
            if (Properties) {
                acc[CodeName] = Properties.value;
            }
            return acc;
        }, {});
    } catch(error) {
        console.error(`Failed to get all GraphQL values from settings table`, error);
        throw error;
    }
}